import { Component, Input, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { NextcloudFile } from 'src/app/classes';
import { BackEndService } from 'src/app/backend-service';

@Component({
  selector: 'app-onlyoffice',
  templateUrl: './onlyoffice.component.html',
  styleUrls: ['./onlyoffice.component.css']
})
export class OnlyofficeComponent implements AfterViewInit {

  _file: NextcloudFile = null;

  @ViewChild("onlyofficeContainer", { static: true }) ooc: ElementRef;

  @Input() set file(file: NextcloudFile) {
    this._file = file;
    if (this._file.href) {
      this._backEndService.requestOO({
        "path": this._file.href,
        "getid": this._file.fileId
      }).subscribe((result: any) => {
        this.ooc.nativeElement.innerHTML = "";
        this.ooc.nativeElement.insertAdjacentHTML('beforeend', '<div id="only-office-inner" class="oo-inner"></div>');
        result.height = "100%";
        result.width = "100%";
        result.events = {
          "onDocumentReady": (d) => {
            console.log(result, d, arguments);
          }
        };
        result.document.permissions.edit = true;
        result.document.permissions.review = true;
        // @ts-ignore
        var docEditor = new DocsAPI.DocEditor("only-office-inner", result);
      }, (result: any) => {
        console.log(result);
      });
    }
  }

  get file(): NextcloudFile {
    return this._file;
  }

  constructor(
    private _backEndService: BackEndService
  ) {

  }

  ngAfterViewInit() {

  }

}
